import * as Sentry from '@sentry/react';

/**
 * Sentry do front (plano de produção, PR6). Só liga quando a imagem foi
 * construída com VITE_SENTRY_DSN. Sem dados pessoais: sem usuário, sem
 * corpo de requisição, e e-mails e números longos somem das mensagens.
 */
const EMAIL = /[^\s@"'<>]+@[^\s@"'<>]+\.[^\s@"'<>]+/g;
const LONG_NUMBER = /\+?\d[\d\s().-]{7,}\d/g;
const scrub = (text?: string) =>
  text?.replace(EMAIL, '[e-mail]').replace(LONG_NUMBER, '[número]');

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
    beforeSend(event) {
      delete event.user;
      if (event.request) {
        delete event.request.headers;
        delete event.request.cookies;
        delete event.request.data;
        if (event.request.url) event.request.url = event.request.url.split('?')[0];
      }
      event.message = scrub(event.message);
      for (const value of event.exception?.values ?? []) value.value = scrub(value.value);
      return event;
    },
    beforeBreadcrumb(crumb) {
      // Cliques e digitação podem carregar nome/telefone de lead: fora.
      if (crumb.category === 'ui.input' || crumb.category === 'ui.click') return null;
      crumb.message = scrub(crumb.message);
      if (crumb.data?.url) crumb.data.url = String(crumb.data.url).split('?')[0];
      return crumb;
    },
  });
}
